
import { Options } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import FormMixin from "../../helpers/mixins/form";
import { User, UserApi } from "../../autogen";
import { Field, Form } from "vee-validate";
import FieldLabel from "../atoms/FieldLabel.vue";
import * as yup from "yup";
import FieldError from "../atoms/FieldError.vue";
import FormError from "../atoms/FormError.vue";
import ActionButton from "@/components/atoms/ActionButton.vue";
type FormValues = {
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
};
@Options({
  components: { Field, Form, FieldLabel, FieldError, ActionButton, FormError }
})
export default class UserForm extends FormMixin {
  @Prop({ type: Object }) user?: User;
  formName = "ユーザー";
  formValues: Partial<FormValues> = {};
  validationSchema!: yup.AnyObjectSchema;

  beforeCreate() {
    this.validationSchema = yup.object({
      username: yup
        .string()
        .trim()
        .required(this.$t("input_required", { field: "ユーザーID" })),
      firstName: yup
        .string()
        .trim()
        .required(this.$t("input_required", { field: "名" })),
      lastName: yup
        .string()
        .trim()
        .required(this.$t("input_required", { field: "姓" })),
      email: yup
        .string()
        .required(this.$t("input_required", { field: "メールアドレス" }))
        .email(this.$t("input_email")),
      password: yup.string().required(),
      role: yup.string().required(this.$t("input_required", { field: "権限" }))
    });
  }

  async beforeMount() {
    await this.setRoles();
    if (this.user) {
      Object.assign(this.formValues, this.user);
    } else {
      this.formValues = {
        username: "",
        firstName: "",
        lastName: "",
        email: "",
        role: "2"
      };
    }
  }
  async onBeforeSubmit(formValues: FormValues) {
    await this.onSubmit(async () => {
      if (this.user) {
        await new UserApi().updateUser({
          clientId: this.$route.params.clientId as string,
          userId: this.user.id,
          updateUserRequest: formValues
        });
      } else {
        await new UserApi().createUser({
          clientId: this.$route.params.clientId as string,
          createUserRequest: formValues
        });
      }
      this.$emit("submitted");
    });
  }
  async onDeleteButtonClick() {
    this.onDelete(async () => {
      await new UserApi().deleteUser({
        clientId: this.$route.params.clientId as string,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        userId: this.user!.id
      });
    }, "従業員を削除します。よろしいでしょうか？\n※削除した場合、従業員は完全に削除されます。\n※適性検査のデータも全て表示されなくなります。");
  }
}
